import { render } from "./RecipientTechnicalDetailsModal.vue?vue&type=template&id=51d286d7&scoped=true&ts=true"
import script from "./RecipientTechnicalDetailsModal.vue?vue&type=script&lang=ts"
export * from "./RecipientTechnicalDetailsModal.vue?vue&type=script&lang=ts"

import "./RecipientTechnicalDetailsModal.vue?vue&type=style&index=0&id=51d286d7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d286d7"]])

export default __exports__